import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import "./assets/reset.scss";
import "../node_modules/leaflet/dist/leaflet.css";
import router from './router';
import GeoUtils from './mixins/GeoUtils.js';
import CarRecommender from './mixins/CarRecommender.js';
import vueCustomElement from 'vue-custom-element';
import Vuetify from 'vuetify/lib';
import Dealer from './services/Dealer.js';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';

import Countly from 'countly-sdk-web';
import VueCountly from 'vue-countly';

import VueClipboard from 'vue-clipboard2';
import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);
// import the library
import VStripeElements from 'v-stripe-elements/lib';
import SolarIcon from './components/SolarIcon';
import Analytics from './mixins/Analytics.js';
import VNumeric from 'vuetify-numeric/vuetify-numeric.umd.min'
import VuePhoneNumberInput from 'vue-phone-number-input';
import PowerTrip from './services/api/PowerTrip';

import axios from 'axios';

import AsyncComputed from 'vue-async-computed';
 
Vue.use(AsyncComputed);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
// and register it
Vue.use(VStripeElements);
Vue.use(VNumeric);
Vue.use(vueCustomElement);
Vue.use(vuetify);
Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.mixin(GeoUtils);
Vue.mixin(CarRecommender);
Vue.mixin(Analytics);

Vue.prototype.$dealer = Dealer;
Vue.prototype.$user = false;
Vue.prototype.$auth;
Vue.prototype.$loaded = false;
Vue.prototype.$carData = [];
Vue.prototype.$modelData = [];
Vue.prototype.$trips = [];
Vue.prototype.$bubble = {
  location: {
    Address: {
      Address: "Nick's EV Shop",
      geometry: { coordinates: [176, -39] },
    },
  },
  kms: 30,
  chargeAtPark: true,
  userPref: 0,
  savingsMode: "home",
  fuelType: "Petrol",
};
axios.defaults.headers.common['X-Version-Powertrip'] = "2.0";
let token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["X-Auth-Powertrip"] = token;
  PowerTrip.login().then(((result) => {
    if (result.id) {
      //load saved trips
      PowerTrip.getTrips().then((trips) => {
        console.log(trips);
      });

      // store token locally
      Vue.prototype.$user = result;
      // Vue.prototype.$auth = data;
      localStorage.setItem("token", result.token);
      axios.defaults.headers.common["X-Auth-Powertrip"] = result.token;
    } else {
      localStorage.removeItem("token");
      axios.defaults.headers.common["X-Auth-Powertrip"] = "";
    }
  }));

}
export const menuBus = new Vue();
export const headerBus = new Vue();
export default new Vuetify(
  {
    theme: {
      dark: Dealer.default_settings.theme.dark,
      themes: {
        light: Dealer.default_settings.theme,
        dark: Dealer.default_settings.theme
      }
    },
    icons: {
      values: {
        solar: {
          component: SolarIcon
        }
      }
    }
  });
App.router = router;
App.vuetify = vuetify;
document.querySelector('power-sell').setAttribute('data-vuetify',"");

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
});
Vue.use(VueCountly, Countly, {
  app_key: 'a160885d3344191fde1d5e2bb6e7649508defb8b',
  url: 'https://analytics.littlemonkey.co.nz'
});
Vue.customElement('power-sell', App, {
  props: [
    "servicecode",
    "routeplan"
  ],
});
